const NO_ITEMS = []

export const selectUnreadCount = (state) => state.notifications?.unreadCount ?? 0

export const selectCountFetchedAt = (state) => state.notifications?.countFetchedAt ?? 0

export const selectNotificationItems = (state) => state.notifications?.items ?? NO_ITEMS

export const selectNotificationsMeta = (state) => state.notifications?.meta ?? null

export const selectNotificationsListStatus = (state) => state.notifications?.listStatus ?? 'idle'

export const selectNextOffset = (state) => state.notifications?.nextOffset ?? 0
